// import {fadeInUp} from 'stitches/animations'

export const lightBotWrapper = {
    margin: '20px auto 0',
    maxWidth: '$questionnaire',
    width: '100%',
}

export const lightBotStep = {
    // animation: `${fadeInUp} 0.5s`,
    marginBottom: '10px',
}

export const avatar = {
    alignItems: 'center',
    color: '$questionnaireLightBotUsername',
    display: 'flex',
    fontSize: '$questionnaireLightBotUsername',
    fontWeight: 'bold',
    gap: '10px',
    margin: '10px 0 -15px 0',
    padding: '0 20px',
}

export const icon = {
    alignItems: 'center',
    display: 'flex',
    height: '$$height',
    width: '$$width',
}
